/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import Image from 'gatsby-core-theme/src/hooks/gatsby-img';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import { generateArray } from 'gatsby-core-theme/src/helpers/generators';
import { Context } from '~context/MainProvider';

import styles from './schedule.module.scss';
import Leagues from './leagues';

const Schedule = ({ pageContext, isStorybook = false }) => {
  const { translations } = useContext(Context) || {};
  const { page } = pageContext;
  const sport = page?.relation?.sport?.name;
  const schedule = page?.relation?.schedule;
  const itemRefs = useRef([]);
  const btnRefs = useRef([]);

  const closeOtherItems = (index) => {
    for (let i = 0; i < itemRefs.current.length; i += 1) {
      if (i !== index) {
        itemRefs.current[i].classList.remove(styles.active);
        btnRefs.current[i].classList.remove(styles.active);
      }
    }
  };

  const toggle = (index) => {
    btnRefs.current[index].classList.toggle(styles.active);
    itemRefs.current[index].classList.toggle(styles.active);
    closeOtherItems(index);
  };

  return (
    <>
      <div className={`${styles.scheduleContainer} ${styles[sport]}`}>
        <div className={styles.bg}>
          <Image filename={`ground-image-${sport}`} alt={`${sport}groundBackground`} />
        </div>
        <h3>{translate(translations, 'schedule', 'Schedule')}</h3>
        <div className={styles.schedule}>
          {generateArray(schedule).map((item, i) => (
            <div key={item.id} className={styles.dayItem}>
              <button
                onClick={() => toggle(i)}
                className={`${styles.dayBtn} ${i === 0 && styles.active} schedule-gtm btn-cta`}
                type="button"
                ref={(el) => (btnRefs.current[i] = el)}
              >
                {`${item?.date?.day} ${item?.date?.day_number}. ${item?.date?.month}`}
                <i />
              </button>
              <div
                className={`${styles.dayContent} ${i === 0 && styles.active}`}
                ref={(el) => (itemRefs.current[i] = el)}
              >
                <Leagues
                  items={generateArray(item?.tournaments)}
                  sport={sport}
                  isStorybook={isStorybook}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={`${styles.arrow} ${styles[sport]}`} />
    </>
  );
};

Schedule.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      path: PropTypes.string,
      relation: PropTypes.shape({}),
    }),
  }).isRequired,
};

export default Schedule;
